import ReCAPTCHA from "./Recaptcha"
import makeAsyncScriptLoader from "react-async-script"

const callbackName = "onloadcallback"
const globalName = "grecaptcha"

function getOptions() {
  return (typeof window !== "undefined" && window.recaptchaOptions) || {}
}

function getURL() {
  const dynamicOptions = getOptions()

  console.log(dynamicOptions)

  const hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com"
  if (dynamicOptions.enterprise) {
    return `https://${hostname}/recaptcha/enterprise.js?onload=${callbackName}&render=explicit`
  }
  return `https://${hostname}/recaptcha/api.js?onload=${callbackName}&render=explicit`
}

export default makeAsyncScriptLoader(getURL, {
  callbackName,
  globalName,
  attributes: getOptions().nonce ? { nonce: getOptions().nonce } : {},
})(ReCAPTCHA)
